__turbopack_context__.v({
  "className": "jetbrains_mono_29f16260-module__8lZFwq__className",
});
